module.exports = "https://hwyhw-static.smarket.net.cn/519/seminar/2202102963240899/minisite/f99c1bc1c0f8bd8ed59980f58b037b7d.jpg";